export const ORG_NAME_MAX_LENGTH = 200;
export const TAG_MAX_LENGTH = 20;
export const COMPANY_NAME_MAX_LENGTH = 50;

export const ACCEPTED_FILE_TYPES = ["image/png", "image/jpg", "image/jpeg", "image/webp", "image/heic", "image/heif", "image/gif", "video/*"];

export const constants = {
	FEATURES: {
		INTEGRATIONS: "INTEGRATIONS",
		MARKETPLACE: "MARKETPLACE",
		ATTRIBUTES: "ATTRIBUTES",
		SCRIBE_INTEGRATIONS: "SCRIBE_INTEGRATIONS"
	},
	CONVERSATION_STATUS: {
		NotStarted: "NotStarted",
		Unread: "Unread",
		Scheduled: "Scheduled",
		Sent: "Sent",
		Delivered: "Delivered",
		InProgress: "InProgress",
		Processing: "Processing",
		ReadyForReview: "ReadyForReview",
		Reviewed: "Reviewed"
	},
	PROJECT_STATUS: {
		NotStarted: "NotStarted",
		InProgress: "InProgress",
		Completed: "Completed"
	},
	FILTER_STATUS: {
		NotStarted: "NotStarted",
		Scheduled: "Scheduled",
		Sent: "Sent",
		InProgress: "InProgress",
		Processing: "Processing",
		ReadyForReview: "ReadyForReview",
		Reviewed: "Reviewed",
		Completed: "Completed"
	},
	CONVERSATION_TYPE: {
		ASYNC: "async",
		SYNC: "sync",
		PHOTOS: "photos",
		UPLOADS: "uploads",
		GOOGLE_REVIEW: "googlereview"
	},
	INITIATION_TYPE: {
		ADMIN: "admin",
		BEACON: "beacon",
		SELF: "self"
	},
	SCHEDULER_STATE: {
		SCHEDULE: "schedule",
		SELECT_DATE: "select-date",
		SELECT_TIME: "select-time",
		CONFIRMATION: "confirmation"
	},
	DIRECTION: {
		INBOUND: "INBOUND",
		OUTBOUND: "OUTBOUND"
	},
	SORT_SESSIONS_VIEW_BY: {
		CREATED_AT: "createdAt",
		READY_FOR_REVIEW: "ReadyForReview"
	},
	REMOVE_ACCESS: {
		label: "Remove Access",
		value: "remove"
	},
	SUBSCRIPTION_STATUS: {
		TRIAL: "trial",
		TRIAL_EXPIRED: "trialExpired",
		ACTIVE: "active",
		PENDING_PAYMENT: "pendingPayment",
		SUSPENDED: "suspended",
		CANCELLED: "cancelled"
	},
	SUBSCRIPTION_ACCOUNT_TYPE: {
		NEW: "new"
	},
	SOCKET_EVENT: {
		ACCOUNT_UPDATE: "account_update",
		CONVERSATION_UPDATE: "conversation_update",
		MASTERDOCUMENT_CREATE: "masterdocument_create",
		MASTERDOCUMENT_DELETE: "masterdocument_delete",
		MASTERRECORDING_DELETE: "masterrecording_delete",
		RECORDINGSESSION_UPDATE: "recordingsession_update",
		UPDATE: "update",
		MENTION: "mention",
		COMMENT: "comment"
	},
	DOCUMENT_TYPE: {
		SNAPSHOT: "snapshot",
		FILE: "file",
		IMAGE: "image",
		DOCUMENT: "document"
	},
	PREMIUM_MESSAGE_ADMIN: "This is a premium feature. Upgrade your subscription to access all features.",
	PREMIUM_MESSAGE_USER: "This is a premium feature. Upgrade your subscription to access all features.",
	areEqual: function (typeName1, typeName2) {
		return typeName1 && typeName2 && typeName1.toUpperCase() == typeName2.toUpperCase();
	}
};
export default constants;
